import React from 'react';
import {OrderType, PlaceApi} from "../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import PopupModal from "../../../../components/Modal/PopupModal";
import MultistoreOrderTypesModalElement from "./MultistoreOrderTypesModalElement";
import {SessionState} from "../../../../services/Session/types";

interface Props {
    orderTypes: OrderType[];
    show: boolean;
    onHide: () => void;
    link: string;
    session: SessionState;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
    place: PlaceApi;
}

const MultistoreOrderTypesModal = ({orderTypes, show, onHide, link, session, setShowAddressModal, place}: Props) => {
    const {t} = useTranslation();

    return (
        <PopupModal
            title={t("modules.multistore.field.select_order_type.title")}
            className="multistore-order-types-modal"
            show={show}
            onHide={onHide}
            bodyContent={
                <div className="d-flex flex-column gap-2 pt-4 elements-container">
                    {orderTypes.map(orderType => (
                        <MultistoreOrderTypesModalElement
                            link={link}
                            orderType={orderType}
                            key={orderType}
                            session={session}
                            setShowAddressModal={setShowAddressModal}
                            place={place}
                        />
                    ))}
                </div>
            }
        />
    )
}

export default MultistoreOrderTypesModal;